/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const input = document.querySelector('.properties__input');
  const counter = document.querySelector('.counter');
  const errorMessage = document.querySelector('.engraving_error-message');
  const submitButton = document.querySelector('.product__submit');

  input.addEventListener('input', (event) => {
    const value = event.target.value;

    // limit input to maximum 15 characters
    if (value.length > 15) {
      event.target.value = value.slice(0, 15);
    }

    // count the number of characters entered
    const count = value.length;

    // update the counter
    counter.textContent = `${count}/15`;

    // check that the input only contains letters from A-Z in caps and regular and numbers consisting of 0-9 characters
    const regex = /^[a-zA-Z0-9]*$/;
    if (!regex.test(value) || count > 15) {
      event.target.classList.add('invalid');
      errorMessage.style.display = 'block';
      submitButton.classList.add('invalid');
    } else {
      event.target.classList.remove('invalid');
      errorMessage.style.display = 'none';
      submitButton.classList.remove('invalid');
    }
  });




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
